import {BaseDTO} from "../../../core/dto/BaseDTO";
import {OrganisationDTO} from "./OrganisationDTO";

export class OrganisationOwnerDTO extends BaseDTO {
  id: number;
  email: string;
  password: string;
  phone: string;
  firstName: string;
  lastName: string;
  userId: string;
  organisations: OrganisationDTO[] = [];

  constructor() {
    super();
  }

  override bindData(obj: any): void {
    if (obj == null) {
      return;
    }
    super.bindData(obj);
    this.id = obj.id;
    this.email = obj.email;
    this.password = obj.password;
    this.phone = obj.phone;
    this.firstName = obj.firstName;
    this.lastName = obj.lastName;
    this.userId = obj.userId;
    
    if (Array.isArray(obj.organisations)) {
      this.organisations = obj.organisations.map((orgData: any) => {
        const organisation = new OrganisationDTO();
        organisation.bindData(orgData);
        return organisation;
      });
    }
  }
}
